// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mobius';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M10.79 6.642c.69-.712 1.456-1.192 2.383-1.192 2.98 0 3.577 2.385 3.577 3.577 0 1.192-.596 3.577-3.577 3.577-3.577 0-4.77-7.154-8.346-7.154-2.98 0-3.577 2.385-3.577 3.577 0 1.192.596 3.577 3.577 3.577.927 0 1.695-.481 2.385-1.194'
  />
);

export const viewBox = '0 0 18 18';
